import {AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {ApiBackendService} from '../../shared/services/api-backend.service';
import {BlogDetail} from '../../shared/entities/blog-detail';
import {DateUtils} from '../../shared/utils/date.utils';
import {BlogDescriptionPar, BlogDescriptionParContent} from '../../shared/entities/blog-description-item';
import {ShareMetaSeoService} from '../../shared/services/share-meta-seo.service';
import {NavbarService} from "../../shared/services/navbar.service";
import {Gallery, GalleryComponent, GalleryItem, ImageItem} from "ng-gallery";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'gryf-blog-detail',
  templateUrl: './blog-detail.component.html',
})
export class BlogDetailComponent implements OnInit, OnDestroy {

  blogDetail: BlogDetail;
  description1Points: string[];
  description2Points: string[];
  description3Points: string[];

  description2items: BlogDescriptionPar[] = [];
  description3items: BlogDescriptionPar[] = [];

  private textSizeSeparator = '$$';
  private textStyleSeparator = '%%';
  private linkSeparator = '@@';
  private linkPrefixes: string[] = ['www', 'http', 'https'];

  // @ViewChild(NgxGalleryComponent, {static: true}) galleryView: NgxGalleryComponent;
  // @ViewChild(GalleryComponent) gallery: GalleryComponent;

  images: GalleryItem[] = [];

  constructor(
    private share: ShareMetaSeoService,
    private navbarService: NavbarService,
    private route: ActivatedRoute,
    private apiBackendService: ApiBackendService,
    private gallery: Gallery,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.share.createLinkForCanonicalURL();
    this.navbarService.navbarInit();
    this.getBlogDetail();
  }

  getBlogDetail(): void {
    let isPhotoLoad = false;

    this.route.params.subscribe(params => {
      this.apiBackendService.getBlogDetailByUrl(params['url'])
        .subscribe(blog => {
          this.blogDetail = blog;
          this.description1Points = this.blogDetail.description1.split('##');
          this.description2Points = this.blogDetail.description2.split('##');
          this.description3Points = this.blogDetail.description3.split('##');

          this.descriptionPointsSplit(this.description2Points, 2);
          this.descriptionPointsSplit(this.description3Points, 3);

          blog.blogPhotos.forEach(blogPhoto => {
            this.apiBackendService.getBase64BlogPhoto(blogPhoto.blogPhotoId)
              .subscribe(photo => {
                if (photo.fileContent) {
                  blogPhoto.base64Content = 'data:image/jpeg;charset=utf-8;base64, ' + photo.fileContent;

                  this.images.push(new ImageItem({ src: blogPhoto.base64Content, thumb: blogPhoto.base64Content, alt: blogPhoto.description1 }));
                  this.gallery.ref().load(this.images);

                  // this.gallery.addImage(new ImageItem({ src: blogPhoto.base64Content, thumb: blogPhoto.base64Content, alt: blogPhoto.description1 }));
                  if (!isPhotoLoad) {
                    this.share.updateSeoData({
                      title: blog.title1 + ' | Gryf',
                      description: blog.title2,
                    });

                    this.share.updateOpenGraphTags(
                      'article',
                      blog.title1 + ' | Gryf',
                      blog.title2,
                      blogPhoto.base64Content
                    );
                    isPhotoLoad = true;
                  }
                }
              }, error => {
                console.error(error);
              });
          });

        }, error => {
          console.error(error);
        });
    }, error => {
      console.error(error);
    });
  }

  getFormattedDate(instantDate: string): any {
    return DateUtils.formatDateSk(instantDate);
  }

  descriptionPointsSplit(splitItems: string[], description: number): void {
    for (const item of splitItems) {
      const parContentArray: BlogDescriptionParContent[] = [];
      let size = null;
      let paragraph = null;

      if (item.charAt(0) <= '9' && item.charAt(0) >= '0') {
        paragraph = item.substring(1);
      } else {
        paragraph = item;
      }

      if (paragraph.includes(this.textSizeSeparator)) {
        switch (parseInt(paragraph.charAt(2), 10)) {
          case 4:
            size = 'h3';
            paragraph = paragraph.slice(3, -2);
            break;
          case 3:
            size = 'h4';
            paragraph = paragraph.slice(3, -2);
            break;
          case 2:
            size = 'h5';
            paragraph = paragraph.slice(3, -2);
            break;
          case 1:
            size = 'h6';
            paragraph = paragraph.slice(3, -2);
            break;
          default:
            size = null;
            paragraph = paragraph.slice(2, -2);
        }
      }

      if (paragraph.includes(this.textStyleSeparator)) {
        let textContentArray = [];
        textContentArray = paragraph.split(this.textStyleSeparator);

        for (let part of textContentArray) {
          if (textContentArray.indexOf(part) % 2 === 0) {
            if (part.includes(this.linkSeparator)) {
              let linksArray = [];
              linksArray = part.split(this.linkSeparator);
              for (let linkPart of linksArray) {
                if (this.linkPrefixes.some(prefix => linkPart.startsWith(prefix))) {
                  linkPart = linkPart.split(' ');
                  parContentArray.push({text: linkPart.shift(), bold: false, italics: false, link: true});
                  parContentArray.push({text: linkPart.join(' '), bold: false, italics: false, link: false});
                } else {
                  if (this.linkPrefixes.some(prefix => linkPart.includes(prefix))) {
                    let hyperLinkArr = [];
                    hyperLinkArr = linkPart.split('--');
                    parContentArray.push({
                      text: hyperLinkArr[0], bold: false, italics: false, link: false, hyperlink: {
                        hyperlinkText: hyperLinkArr[1].substr(0, hyperLinkArr[1].indexOf(' '))
                      }
                    });
                    parContentArray.push({
                      text: hyperLinkArr[1].substr(hyperLinkArr[1].indexOf(' ') + 1),
                      bold: false, italics: false, link: false
                    });
                  } else {
                    parContentArray.push({text: linkPart, bold: false, italics: false, link: false});
                  }
                }
              }
            } else {
              parContentArray.push({text: part, bold: false, italics: false, link: false});
            }
          } else {
            const textType = part.substring(0, 2);
            if (textType === 'B_') {
              part = part.slice(2);
              parContentArray.push({text: part, bold: true, italics: false, link: false});
            } else if (textType === 'I_') {
              part = part.slice(2);
              parContentArray.push({text: part, bold: false, italics: true, link: false});
            } else {
              parContentArray.push({text: part, bold: true, italics: false, link: false});
            }
          }
        }
      } else {
        if (paragraph.includes(this.linkSeparator)) {
          let linksArray = [];
          linksArray = paragraph.split(this.linkSeparator);
          for (let linkPart of linksArray) {
            if (this.linkPrefixes.some(prefix => linkPart.startsWith(prefix))) {
              linkPart = linkPart.split(' ');
              parContentArray.push({text: linkPart.shift(), bold: false, italics: false, link: true});
              parContentArray.push({text: linkPart.join(' '), bold: false, italics: false, link: false});
            } else {
              if (this.linkPrefixes.some(prefix => linkPart.includes(prefix))) {
                let hyperLinkArr = [];
                hyperLinkArr = linkPart.split('--');
                parContentArray.push({
                  text: hyperLinkArr[0], bold: false, italics: false, link: false, hyperlink: {
                    hyperlinkText: hyperLinkArr[1].substr(0, hyperLinkArr[1].indexOf(' '))
                  }
                });
                parContentArray.push({
                  text: hyperLinkArr[1].substr(hyperLinkArr[1].indexOf(' ') + 1),
                  bold: false, italics: false, link: false
                });
              } else {
                parContentArray.push({text: linkPart, bold: false, italics: false, link: false});
              }
            }
          }
        } else {
          parContentArray.push({text: paragraph, bold: false, italics: false, link: false});
        }
      }

      switch (description) {
        case 2: {
          this.description2items.push({content: parContentArray, space: item.charAt(0), size: size});
          break;
        }
        case 3: {
          this.description3items.push({content: parContentArray, space: item.charAt(0), size: size});
          break;
        }
      }
    }

    switch (description) {
      case 2: {
        this.description2items.shift();
        break;
      }
      case 3: {
        this.description3items.shift();
        break;
      }
    }
  }

  counter(n: string): any[] {
    if (n <= '9' && n >= '0') {
      return Array(parseInt(n, 10));
    } else {
      return Array(parseInt('1', 10));
    }
  }

  ngOnDestroy(): void {
    this.navbarService.navbarDestroy();
  }

}
